define([
    '../Util/defaultValue',
    '../Util/defined',
    '../Util/defineProperties',
    '../Util/bind',
    '../Util/encode',
    '../Util/callbackSystem',
    '../System/ColorObj'
], function (
    defaultValue,
    defined,
    defineProperties,
    bind,
    encode,
    callbackSystem,
    ColorObj
) {
    'use strict'

    class GlobalFog {
        /**
         * @description 雾颜色。
         * @type {ColorObj}
         */
        color
        /**
         * @description 采样数。
         * @type {Number}
         * @default 3
         */
        sampleNum
        /**
         * @description 常熟。
         * @type {Number}
         * @default 26
         */
        paramA
        /**
         * @description 幂数。
         * @type {Number}
         * @default 50
         */
        paramB
        /**
         * @description 全球雾显隐状态。
         * @type {Boolean}
         * @default true
         */
        bVisible
        /**
         * @description 全球雾对象uuid。
         * @type {String}
         * @readonly
         */
        avatarUuid = null
        /**
         * @description 全球雾组件uuid。
         * @type {String}
         * @readonly
         */
        componentUuid = null
        /**
         * @description GlobalFog在CooWasm中类名。
         * @private
         * @readonly
         */
        className = "GlobalFog"
        static avatarType = "deSMP.Avatar.EnvironmentAvatar"
        static componentType = "AvatarComponent.Environment.GlobalFogComponent"

        /**
         * 全球雾。
         * <br /><br />
         * <div align='center'>
         * <img src='images/GlobalFog.gif' width='900' height='650' /><br />
         * 全球雾效果图
         * </div>
         * 
         * @demo {@link http://lbs.zjkelan.com/GlobalFog.html|CooWasm GlobalFog demo}
         * @alias GlobalFog
         * @constructor
         *
         * @param {Object} props 包含如下属性的Object：
         * @param {ColorObj} [props.color = ColorObj.fromBytes(204, 204, 255, 255.0)] 雾颜色。
         * @param {Boolean} [props.bVisible = true] 雾显隐状态。
         * @param {Number} [props.sampleNum = 3] 采样数。
         * @param {Number} [props.paramA = 26] 常熟。
         * @param {Number} [props.paramB = 50] 幂数。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * var fog = new CooWasm.GlobalFog({},(state)=>{console.log("load status:" + state)})
         */
        constructor(props, callback) {
            if (!defined(props)) {
                props = {}
                return
            }
            if(defined(props.build) && props.build == true){
                return
            }
            this.color = defaultValue(props.color, ColorObj.fromBytes(204, 204, 255, 255.0))
            this.bVisible = defaultValue(props.bVisible, true)
            this.sampleNum = defaultValue(props.sampleNum, 3)
            this.paramA = defaultValue(props.paramA, 26)
            this.paramB = defaultValue(props.paramB, 50)
            //create avatars
            var aCategory = encode("deSMP.Avatar")
            var aName = encode("EnvironmentAvatar")
            var cCategory = encode("AvatarComponent.Environment")
            var cName = encode("GlobalFogComponent")
            var aProps = ""
            var cProps = ""
            aProps += this.toStr("bVisible", props.bVisible, "Visible")
            cProps += this.toStr("color", props.color, "FogColor")
            cProps += this.toStr("paramA", props.paramA, "ParameterA")
            cProps += this.toStr("paramB", props.paramB, "ParameterB")
            cProps += this.toStr("sampleNum", props.sampleNum, "SampleNum")
            
            var idInfo = Element.prototype.NativeAPI.LoadAvatarAndComponent(encode(""), aCategory, aName, encode(aProps), cCategory, cName, encode(cProps), encode(""), encode(""), this.bVisible, true)
            if (idInfo != "") {
                var idArray = idInfo.split('#$%')
                this.avatarUuid = idArray[0]
                this.componentUuid = idArray[1]
                callbackSystem.register("LoadAvatarAndComponent", this.avatarUuid, (state) => {
                    this.getProperties()
                    if (defined(callback)) {
                        callback(state)
                    }
                    Element.prototype.Map.globalFogs.push(this)
                })
                //console.log("GlobalFog avatarUuid:" + this.avatarUuid + " componentUuid:" + this.componentUuid)
            }
        }

        /**
         * <p>
         * 更新单个或者多个对象属性，使之立即生效。
         * </p>
         *
         * @param {Object} [props] 包含如下属性的Object。
         * @param {ColorObj} [props.color] 雾颜色。
         * @param {Boolean} [props.bVisible] 雾显隐状态。
         * @param {Number} [props.sampleNum] 采样数。
         * @param {Number} [props.paramA] 常熟。
         * @param {Number} [props.paramB] 幂数。
         * @param {CallbackBoolean} [callback=null] 加载成功后触发的函数回调。
         * @example
         * fog.update({
         *    bVisible:false
         * },(state)=>{console.log("update status:" + state)})
         */
        update(props, callback) {
            let avatarProps = ""
            let componentProps = ""
            if (defined(props)) {
                if (defined(props.bVisible)) {
                    this.bVisible = props.bVisible
                    avatarProps += "Visible:" + this.bVisible + "|"
                }
                if (defined(props.color)) {
                    this.color = props.color
                    componentProps += "FogColor:" + this.color.toStr() + "|"
                }
                if (defined(props.sampleNum)) {
                    this.sampleNum = props.sampleNum
                    componentProps += "SampleNum:" + String(this.sampleNum) + "|"
                }
                if (defined(props.paramA)) {
                    this.paramA = props.paramA
                    componentProps += "ParameterA:" + String(this.paramA) + "|"
                }
                if (defined(props.paramB)) {
                    this.paramB = props.paramB
                    componentProps += "ParameterB:" + String(this.paramB) + "|"
                }
                callbackSystem.register("UpdateAvatarAndComponent", this.avatarUuid, (state) => {
                    if (defined(callback)) {
                        callback(state)
                    }
                })
                Element.prototype.NativeAPI.UpdateAvatarAndComponent(encode(this.avatarUuid), encode(this.componentUuid), encode(avatarProps), encode(componentProps), defined(callback))
            }
        }
        toStr(memName, value, key) {
            let result = ""
            if (defined(value)) {
                this[memName] = value
                if (typeof value.toStr === 'function') {
                    result = key + ":" + value.toStr() + "|"
                } else {
                    result = key + ":" + value + "|"
                }
            }
            return result
        }
        /**
         * 获取全球雾包含的属性。
         * @returns {Boolean} 是否获取成功。获取成功时，会自动赋值给属性。
         * @example
         * fog.getProperties()
         */
        getProperties() {
            if (!defined(this.avatarUuid) || !defined(this.componentUuid)) {
                console.log("uuid require!")
                return false
            }
            let pAvatarUuid = Element.prototype.NativeAPI.Uuid_New()
            Element.prototype.NativeAPI.Uuid_SetId(pAvatarUuid, encode(this.avatarUuid))
            let pAvatar = Element.prototype.NativeAPI.MapImpl_getAvatar(pAvatarUuid)
            let avatarPropSize = Element.prototype.NativeAPI.Avatar_GetPropertiesSize(pAvatar)
            for (let i = 0; i < avatarPropSize; ++i) {
                let pProp = Element.prototype.NativeAPI.Avatar_GetProperty(pAvatar, i)
                let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                if (name == "Visible") {
                    if (value == "true" || value == "1") {
                        this.bVisible = true
                    } else {
                        this.bVisible = false
                    }
                }
            }
            let avatarAcSize = Element.prototype.NativeAPI.Avatar_GetAvatarComponentsSize(pAvatar)
            for (let j = 0; j < avatarAcSize; ++j) {
                let pAc = Element.prototype.NativeAPI.Avatar_GetAvatarComponent(pAvatar, j)
                let propSize = Element.prototype.NativeAPI.AvatarComponent_GetPropertiesSize(pAc)
                let pUuid = Element.prototype.NativeAPI.AvatarComponent_GetUuid(pAc)
                let uuid = Element.prototype.NativeAPI.Uuid_GetId(pUuid)
                this.componentUuid = uuid
                for (let z = 0; z < propSize; ++z) {
                    let pProp = Element.prototype.NativeAPI.AvatarComponent_GetProperty(pAc, z)
                    let name = Element.prototype.NativeAPI.Property_GetName(pProp)
                    let value = Element.prototype.NativeAPI.Property_GetValue(pProp)
                    if (name == "FogColor") {
                        this.color = ColorObj.fromStr(value)
                    } else if (name == "ParameterA") {
                        this.paramA = Number(value)
                    } else if (name == "ParameterB") {
                        this.paramB = Number(value)
                    } else if (name == "SampleNum") {
                        this.sampleNum = Number(value)
                    }
                }
            }
            Element.prototype.NativeAPI.Avatar_Delete(pAvatar)
            Element.prototype.NativeAPI.Uuid_Delete(pAvatarUuid)
            return true
        }

        /**
         * 从场景中销毁自身。
         * @param {CallbackBoolean} [callback=null] 销毁后触发的函数回调。
         * @returns null 空值。
         * @example
         * fog = fog.destroy((state)=>{console.log("destroy status:" + state)})
         */
        destroy(callback) {
            if(!defined(this.avatarUuid)){
                console.log("avatarUuid is null!")
                return null
            }
            callbackSystem.register("RemoveAvatar", this.avatarUuid, (state) => {
                if (defined(callback)) {
                    callback(state)
                }
                Element.prototype.Map.globalFogs = Element.prototype.Map.globalFogs.filter(item => item !== this)
                callbackSystem.remove("LoadAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("UpdateAvatarAndComponent", this.avatarUuid)
                callbackSystem.remove("RemoveAvatar", this.avatarUuid)
                this.avatarUuid = null
                this.componentUuid = null
            })
            Element.prototype.NativeAPI.RemoveAvatar(encode(this.avatarUuid))
            return null
        }
    }
    return GlobalFog
})